import { landOptions } from '@/core/common/iso3166Countries';

export const GESCHLECHT_OPTIONS = [
  { value: 'M', text: 'Männlich' },
  { value: 'F', text: 'Weiblich' },
  { value: 'X', text: 'Divers / Unbestimmt' },
];

export const PASSART_OPTIONS = [
  { value: 'PersonalausweisDni', text: 'Personalausweis / DNI' },
  { value: 'OrdentlicherReisepass', text: 'Ordentlicher Reisepass' },
  { value: 'Dienstpass', text: 'Dienstpass' },
  { value: 'Diplomatenpass', text: 'Diplomatenpass' },
  { value: 'VorlaeufigerReisepass', text: 'Vorläufiger Reisepass' },
  { value: 'Notpass', text: 'Notpass' },
  { value: 'Kollektivpass', text: 'Kollektivpass' },
  { value: 'Familienpass', text: 'Familienpass' },
];

// Zuordnung ISO-3166-Ländercode zu deutscher Nationalitätsbezeichnung für das Nationalitäts-Dropdown
// DE, AT und CH fehlen hier bewusst, sie werden in NATIONALITAET_OPTIONS vorangestellt
const NATIONALITAET_BY_LAENDERCODE = {
  AF: 'Afghanisch',
  EG: 'Ägyptisch',
  AL: 'Albanisch',
  DZ: 'Algerisch',
  US: 'Amerikanisch',
  AD: 'Andorranisch',
  AO: 'Angolanisch',
  AR: 'Argentinisch',
  AM: 'Armenisch',
  AZ: 'Aserbaidschanisch',
  ET: 'Äthiopisch',
  AU: 'Australisch',
  BD: 'Bangladeschisch',
  BE: 'Belgisch',
  BO: 'Bolivianisch',
  BA: 'Bosnisch-Herzegowinisch',
  BR: 'Brasilianisch',
  GB: 'Britisch',
  BG: 'Bulgarisch',
  CL: 'Chilenisch',
  CN: 'Chinesisch',
  CR: 'Costa-Ricanisch',
  DK: 'Dänisch',
  DO: 'Dominikanisch',
  EC: 'Ecuadorianisch',
  EE: 'Estnisch',
  FI: 'Finnisch',
  FR: 'Französisch',
  GE: 'Georgisch',
  GH: 'Ghanaisch',
  GR: 'Griechisch',
  GT: 'Guatemaltekisch',
  IN: 'Indisch',
  ID: 'Indonesisch',
  IQ: 'Irakisch',
  IR: 'Iranisch',
  IE: 'Irisch',
  IS: 'Isländisch',
  IL: 'Israelisch',
  IT: 'Italienisch',
  JM: 'Jamaikanisch',
  JP: 'Japanisch',
  YE: 'Jemenitisch',
  JO: 'Jordanisch',
  KH: 'Kambodschanisch',
  CM: 'Kamerunisch',
  CA: 'Kanadisch',
  KZ: 'Kasachisch',
  QA: 'Katarisch',
  KE: 'Kenianisch',
  KG: 'Kirgisisch',
  CO: 'Kolumbianisch',
  CD: 'Kongolesisch',
  HR: 'Kroatisch',
  CU: 'Kubanisch',
  KW: 'Kuwaitisch',
  LA: 'Laotisch',
  LV: 'Lettisch',
  LB: 'Libanesisch',
  LY: 'Libysch',
  LI: 'Liechtensteinisch',
  LT: 'Litauisch',
  LU: 'Luxemburgisch',
  MG: 'Madagassisch',
  MY: 'Malaysisch',
  MT: 'Maltesisch',
  MA: 'Marokkanisch',
  MU: 'Mauritisch',
  MK: 'Mazedonisch',
  MX: 'Mexikanisch',
  MD: 'Moldauisch',
  MC: 'Monegassisch',
  MN: 'Mongolisch',
  ME: 'Montenegrinisch',
  MZ: 'Mosambikanisch',
  MM: 'Myanmarisch',
  NA: 'Namibisch',
  NP: 'Nepalesisch',
  NZ: 'Neuseeländisch',
  NI: 'Nicaraguanisch',
  NL: 'Niederländisch',
  NG: 'Nigerianisch',
  NO: 'Norwegisch',
  OM: 'Omanisch',
  PK: 'Pakistanisch',
  PA: 'Panamaisch',
  PY: 'Paraguayisch',
  PE: 'Peruanisch',
  PH: 'Philippinisch',
  PL: 'Polnisch',
  PT: 'Portugiesisch',
  RW: 'Ruandisch',
  RO: 'Rumänisch',
  RU: 'Russisch',
  ZM: 'Sambisch',
  SA: 'Saudi-Arabisch',
  SE: 'Schwedisch',
  SN: 'Senegalesisch',
  RS: 'Serbisch',
  ZW: 'Simbabwisch',
  SG: 'Singapurisch',
  SK: 'Slowakisch',
  SI: 'Slowenisch',
  ES: 'Spanisch',
  LK: 'Sri-Lankisch',
  ZA: 'Südafrikanisch',
  KR: 'Südkoreanisch',
  SY: 'Syrisch',
  TJ: 'Tadschikisch',
  TW: 'Taiwanesisch',
  TZ: 'Tansanisch',
  TH: 'Thailändisch',
  CZ: 'Tschechisch',
  TN: 'Tunesisch',
  TR: 'Türkisch',
  TM: 'Turkmenisch',
  UG: 'Ugandisch',
  UA: 'Ukrainisch',
  HU: 'Ungarisch',
  UY: 'Uruguayisch',
  UZ: 'Usbekisch',
  VE: 'Venezolanisch',
  VN: 'Vietnamesisch',
  BY: 'Weißrussisch',
  CY: 'Zyprisch',
};

const DACH_CODES = ['DE', 'AT', 'CH'];

// Stellt die DACH-Optionen an den Anfang und sortiert die übrigen alphabetisch nach Anzeigetext
function mitDachZuerst(dachOptions, restOptions) {
  return [...dachOptions, ...restOptions.sort((a, b) => a.text.localeCompare(b.text, 'de'))];
}

export const NATIONALITAET_OPTIONS = mitDachZuerst(
  [
    { value: 'DE', text: 'Deutsch' },
    { value: 'AT', text: 'Österreichisch' },
    { value: 'CH', text: 'Schweizerisch' },
  ],
  Object.entries(NATIONALITAET_BY_LAENDERCODE).map(([code, text]) => ({ value: code, text }))
);

// angezeigt wird der deutsche Ländername; die DACH-Länder stehen am Anfang
// die Länder werden asynchron in den Store geladen, daher werden die Optionen bei jedem Aufruf ermittelt
export function getLandOptions() {
  const alleOptions = landOptions();
  return mitDachZuerst(
    DACH_CODES.map(code => alleOptions.find(option => option.value === code)).filter(
      option => option != null
    ),
    alleOptions.filter(option => !DACH_CODES.includes(option.value))
  );
}

// Felddefinitionen der persönlichen Daten eines Teilnehmers; über flags wird gesteuert,
// welche Flags der Releaseprozess-Konfiguration das Feld als Pflichtfeld markieren
// readonly: Feld ist auch mit Bearbeitungsrecht nicht editierbar
// optional: Feld ist kein Pflichtfeld und zeigt daher kein Status-Icon
// suchbar: Auswahlfeld wird mit Suchfeld dargestellt
export const PERSOENLICHE_FELDER = [
  {
    key: 'geburtsdatum',
    label: 'Geburtsdatum',
    type: 'date',
    flags: ['geburtsdatumRequired', 'geburtsdatumRequiredFlug'],
  },
  {
    key: 'nationalitaet',
    label: 'Nationalität',
    type: 'select',
    options: NATIONALITAET_OPTIONS,
    suchbar: true,
    flags: ['nationalitaetRequired', 'nationalitaetRequiredFlug'],
  },
  {
    key: 'geschlecht',
    label: 'Geschlecht',
    type: 'select',
    options: GESCHLECHT_OPTIONS,
    flags: ['geschlechtRequired', 'geschlechtRequiredFlug'],
  },
  {
    key: 'geburtsort',
    label: 'Geburtsort',
    type: 'text',
    flags: ['geburtsortRequired', 'geburtsortRequiredFlug'],
  },
  {
    key: 'geburtsland',
    label: 'Geburtsland',
    type: 'select',
    suchbar: true,
    flags: ['geburtslandRequired', 'geburtslandRequiredFlug'],
  },
  {
    key: 'berufsbezeichnung',
    label: 'Berufsbezeichnung',
    type: 'text',
    flags: ['berufsbezeichnungRequired'],
  },
];

// Felddefinitionen der Passdaten, gleicher Aufbau wie PERSOENLICHE_FELDER
export const PASS_FELDER = [
  {
    key: 'passNummer',
    label: 'Passnummer',
    type: 'text',
    flags: ['passNummerRequired', 'passNummerRequiredFlug'],
  },
  {
    // Der Passname wird in Blank gepflegt und ist hier nur zur Anzeige
    key: 'passName',
    label: 'Passname',
    type: 'text',
    readonly: true,
    optional: true,
    flags: [],
  },
  {
    // Die Passart kommt aus dem Kundenformular oder wird in der Releaseprüfung gesetzt
    // die Optionen stammen aus den validePassarten der Konfiguration, siehe getPassartOptions
    key: 'passArt',
    label: 'Passart',
    type: 'select',
    placeholder: '-',
    flags: ['passartRequired', 'passartRequiredFlug'],
  },
  {
    key: 'passAusstellungsdatum',
    label: 'Ausgestellt am',
    type: 'date',
    flags: ['passAusstellungsdatumRequired', 'passAusstellungsdatumRequiredFlug'],
  },
  {
    key: 'passGueltigkeitsdatum',
    label: 'Gültig bis',
    type: 'date',
    flags: ['passGueltigkeitsdatumRequired', 'passGueltigkeitsdatumRequiredFlug'],
  },
  {
    key: 'passOrt',
    label: 'Ausstellungsort',
    type: 'text',
    flags: ['passOrtRequired', 'passOrtRequiredFlug'],
  },
  {
    key: 'passLand',
    label: 'Ausstellungsland',
    type: 'select',
    suchbar: true,
    flags: ['passLandRequired', 'passLandRequiredFlug'],
  },
];

// Dokumenttypen mit den zugehörigen Konfigurationsflags
// nur konfigurationsrelevante Typen
export const DOKUMENT_TYPEN = [
  { key: 'visakopie', label: 'Visakopie', apiValue: 'Visakopie', flags: ['visakopieRequired'] },
  {
    key: 'passkopieColor',
    label: 'Passfarbkopie',
    apiValue: 'PasskopieColored',
    flags: ['passkopieColorRequired', 'passkopieColorRequiredFlug'],
  },
  {
    key: 'passfoto',
    label: 'Passfoto',
    apiValue: 'Passfoto',
    flags: ['passfotoRequired', 'passfotoRequiredFlug'],
  },
  {
    key: 'versicherungsnachweis',
    label: 'Versicherungsnachweis',
    apiValue: 'Versicherungsnachweis',
    flags: ['versicherungsnachweisRequired'],
  },
  {
    key: 'verzichtserklaerung',
    label: 'Verzichtserklärung',
    apiValue: 'Verzichtserklaerung',
    flags: ['verzichtserklaerungRequired'],
  },
  { key: 'loiAntrag', label: 'LOI-Antrag', apiValue: 'LoiAntrag', flags: ['loiAntragRequired'] },
  {
    key: 'einverstaendnisformular',
    label: 'Einverständniserklärung',
    apiValue: 'Einverstaendnisformular',
    flags: ['einverstaendnisformularRequired'],
  },
  {
    key: 'referenznummerAntrag',
    label: 'Referenznr.-Antrag',
    apiValue: 'ReferenznummerAntrag',
    flags: ['referenznummerAntragRequired'],
  },
  // Immer verfügbare Kategorie ohne Konfigurationsflag, erlaubt mehrere Dokumente
  {
    key: 'sonstiges',
    label: 'Sonstiges',
    apiValue: 'Sonstiges',
    flags: [],
    optional: true,
    maxAnzahl: 5,
    hinweis:
      'Für Dokumente, die keiner bestehenden Kategorie zugeordnet werden können, z. B. Fernglas-Spezifikationen oder Passkopien von Teilnehmern unter 16 Jahren.',
  },
];

export function getDokumentTypKeyFromApiValue(apiValue) {
  if (apiValue == null) return null;
  return DOKUMENT_TYPEN.find(typ => typ.apiValue === apiValue)?.key || apiValue;
}

export function getDokumentTypLabelFromApiValue(apiValue) {
  if (apiValue == null) return null;
  return DOKUMENT_TYPEN.find(typ => typ.apiValue === apiValue)?.label || apiValue;
}
